import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageArticles,
} from '../pages/articles';

const RouteArticles = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageArticles />
      </Route>
    </Switch>
  );
};

export default RouteArticles;
